import React, {Component, PropTypes} from 'react'
import {findDOMNode} from 'react-dom'
import maps from '../google/maps'
import silverStyle from '../resources/map/style/silver.json'

export function percentageStyle({identify}) {
    return (value) => {
        const percentage = identify(value)
        const color = (percentage < 0.5 && 'red') || (percentage < 0.75 && 'yellow') || 'green'

        return {
            fillColor: color,
            strokeColor: color,
            strokeWeight: 1,
            strokeOpacity: 0.5
        }
    }
}

function geoJsonMapper(display, identify) {
    return (value) => {
        return Promise.resolve(display(value)).then((geoJson) => {
            return geoJson && {
                ...geoJson,
                properties: {
                    ...geoJson.properties,
                    _id: identify(value)
                }
            }
        })
    }
}

class Map extends Component {
    static propTypes = {
        ratio: PropTypes.number,
        style: PropTypes.any,
        display: PropTypes.func,
        identify: PropTypes.func,
        value: PropTypes.array.isRequired,
    }

    static defaultProps = {
        display: (v) => v,
        identify: (v) => v
    }

    constructor(props) {
        super(props)

        this.state = {
            geoJsons: []
        }
    }

    componentWillMount() {
        const {display, identify, value} = this.props

        Promise.all(value.map(geoJsonMapper(display, identify))).then((geoJsons) => {
            const filteredGeoJsons = geoJsons.filter((f) => f)
            this.setState({geoJsons: filteredGeoJsons})
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value != this.props.value) {
            const {display, identify, value} = nextProps

            Promise.all(value.map(geoJsonMapper(display, identify))).then((geoJsons) => {
                const filteredGeoJsons = geoJsons.filter((f) => f)
                this.setState({geoJsons: filteredGeoJsons})
            })
        }
    }

    _click(event) {
        const {identify, value, onClick} = this.props

        const item = value.find((v) => event.feature.getProperty('_id') == identify(v))

        if (item) {
            onClick(event, item)
        }
    }

    _style(feature) {
        const {identify, value, style} = this.props

        const item = value.find((v) => feature.getProperty('_id') == identify(v))

        if (item) {
            return style(item)
        }
        return null
    }

    componentDidMount() {
        const {style, display, identify, value, onClick, ...options} = this.props
        const {geoJsons} = this.state

        this._map = new maps.Map(findDOMNode(this), {
            center: {lat: 0, lng: 0},
            zoom: 4,
            disableDefaultUI: true,
            gestureHandling: 'none',
            zoomControl: false,
            ...options
        })

        this._map.mapTypes.set('silver', new maps.StyledMapType(silverStyle, {name: 'Silver map'}))
        this._map.setMapTypeId('silver')

        if (style) {
            this._map.data.setStyle((f) => this._style(f))
        }

        if (onClick) {
            this._map.data.addListener('click', (e) => this._click(e))

            this._map.data.addListener('mouseover', (event) => {
                this._map.data.revertStyle()
                this._map.data.overrideStyle(event.feature, {fillOpacity: 0.5})
            })

            this._map.data.addListener('mouseout', (event) => {
                this._map.data.revertStyle()
            })
        }

        this._features = geoJsons.reduce((result, geoJson) => {
            result.push(...this._map.data.addGeoJson(geoJson))
            return result  
        }, [])

        // pan and zoom to fit the features
        this._bounds = new maps.LatLngBounds()
        this._features.forEach((feature) => {
            feature.getGeometry().forEachLatLng((latlng) => {
                this._bounds.extend(latlng)
            })
        })
        this._map.fitBounds(this._bounds)
    }

    componentDidUpdate() {
        const {geoJsons} = this.state

        this._features.forEach((feature) => {
            this._map.data.remove(feature)
        })

        this._features = geoJsons.reduce((result, geoJson) => {
            result.push(...this._map.data.addGeoJson(geoJson))
            return result  
        }, [])

        // pan and zoom to fit the features
        this._bounds = new maps.LatLngBounds()
        this._features.forEach((feature) => {
            feature.getGeometry().forEachLatLng((latlng) => {
                this._bounds.extend(latlng)
            })
        })
        this._map.fitBounds(this._bounds)
    }

    render() {
        const {ratio} = this.props

        const defaultStyle = {
            paddingBottom: ratio && (100 / ratio + '%') || 'unset',
            height: !ratio && '100%' || 'unset'
        }

        return (
            <div
                style={defaultStyle}>
            </div>
        )
    }
}

export default Map


// WEBPACK FOOTER //
// ./lib/core/components/Map.js